module.exports = __webpack_public_path__ + "lp/img/scaling_icon_dark.e67a19d7.svg";